import React, { FC, useEffect, useState, useMemo, useRef } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { observer } from 'mobx-react'
import { IonContent, IonPage } from '@ionic/react'
import { storeDisplayMobx } from '@mobx/app'
import { storeMobx } from 'restaurant'
import Header from '../components/Header'
import StoreItem from '../components/StoreItem'
import { modalLayer, useHistoryNew } from '@utils'
import './index.scss'
import StoreDetailModal from '../components/StoreDetailModal'

// interface
interface IProps extends IPage, RouteComponentProps {
  mapType?: string;
  locationOBJ: {
    latitude: string;
    longitude: string;
  };
}

// 存储计算结果
const lineToResult = {}

/** 选择门店页 */
const StoreDisplayList: FC<IProps> = (props) => {
  const history = useHistoryNew()
  const [height, setHeight] = useState(420)
  const [storeStyleMap, setStoreStyleMap] = useState({} as {
    [storeId: number]: {
      left: number;
      top: number;
    };
  })
  const { cityName } = props.match?.params as any
  const { storeCityMap } = storeDisplayMobx
  const storeList = storeCityMap[cityName]
  const waterfallBoxEle: any = useRef()

  const hashStore = useMemo(() => {
    return storeList.map(p => p.storeId).join('')
  }, [storeList])

  const handleBack = () => {
    history.goBack()
  }
  const handleStore = (store) => {
    modalLayer(StoreDetailModal,
      { data: store, },
      'StoreDetailModal')
      .then((type: any) => {
        if (type === 'menu') {
          storeMobx.initInfo(store)
          history.replace('/menu')
        }
      })
  }
  const calcWaterfall = () => {
    const payload = storeDisplayMobx.waterfall(storeList, waterfallBoxEle)
    if (payload) {
      const { styleMap, height } = payload
      setStoreStyleMap(styleMap)
      setHeight(height)
    } else {
      setTimeout(() => {
        calcWaterfall()
      }, 300)
    }
  }
  useEffect(() => {
    storeDisplayMobx.setStoreList(storeMobx.viewStoreList)
  }, [storeMobx.viewStoreList])
  useEffect(() => {
    if (storeList.length && hashStore) {
      if (lineToResult[hashStore]) {
        setStoreStyleMap(lineToResult[hashStore].styleMap)
        setHeight(lineToResult[hashStore].height)
      } else {
        setTimeout(() => {
          calcWaterfall()
        }, 50)
      }
    }
  }, [storeList, hashStore])

  return (
    <IonPage className='store-list-page'>
      <Header onBack={handleBack} />
      <IonContent>
        <div className='store-list-city-name'>
          <div className='bg-txt'>CITY</div>
          <div className='city'>{cityName}</div>
        </div>
        <div className='store-list-wrapper' style={{ height: `${height}px` }} ref={waterfallBoxEle}>
          {
            storeList.map((store) => {
              return <StoreItem onClick={() => handleStore(store)} style={storeStyleMap[store.storeId] || { visibility: 'hidden' }} key={store.storeId} data={store} />
            })
          }
        </div>
      </IonContent>
    </IonPage>
  )
}

export default observer(StoreDisplayList)
